// extracted by mini-css-extract-plugin
export var active = "_70-b";
export var activeIndicator = "_70-6";
export var animate = "_70-a";
export var disabled = "_70-c";
export var flat = "_70-1";
export var fullWidth = "_70-3";
export var lg = "_70-9";
export var md = "_70-8";
export var redoButtonTabGroup = "_70-0";
export var sm = "_70-7";
export var tabButton = "_70-4";
export var tabButtonsContainer = "_70-2";
export var xs = "_70-5";